import React from "react";
import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import IntroOffer from "@/components/landing/IntroOffer";
import About from "@/components/landing/About";
import ServicesCompanies from "@/components/landing/ServicesCompanies";
import ServicesCandidates from "@/components/landing/ServicesCandidates";
import WhyChooseUs from "@/components/landing/WhyChooseUs";
import OurProcess from "@/components/landing/OurProcess";
import IndustriesServe from "@/components/landing/IndustriesServe";
import Pricing from "@/components/landing/Pricing";
import ContactSection from "@/components/landing/ContactSection";
import Footer from "@/components/landing/Footer";
import WhatsAppButton from "@/components/landing/WhatsAppButton";

export default function HomePage() {
  return (
    <div className="min-h-screen bg-brand-bg text-brand-ink" data-testid="home-page">
      <Navbar />
      <main>
        <Hero />
        <IntroOffer />
        <About />
        <ServicesCompanies />
        <ServicesCandidates />
        <WhyChooseUs />
        <OurProcess />
        <IndustriesServe />
        <Pricing />
        <ContactSection />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}
